import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SetupHealthChecks from 'client/components/SetupHealthChecks/SetupHealthChecks';

const SrSetupHealth = ({ setupHealth, listingId }) => {
  return (
    <SrBox>
      <SetupHealthChecks setupHealth={setupHealth} listingId={listingId} />
    </SrBox>
  );
};

SrSetupHealth.propTypes = {
  setupHealth: PropTypes.object.isRequired,
  listingId: PropTypes.number.isRequired,
};

SrSetupHealth.displayName = 'SrSetupHealth';

export default SrSetupHealth;
